module.exports = __webpack_public_path__ + "static/img/RAPZ1-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ1-G_1.png
// module id = kcMk
// module chunks = 0